import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/addr.png'
import _imports_1 from '../../assets/tel.png'


const _withScopeId = n => (_pushScopeId("data-v-40e97e71"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "main-con" }
const _hoisted_3 = { class: "white-radius" }
const _hoisted_4 = { class: "cls-con" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "black" }
const _hoisted_7 = {
  class: "cls-con",
  style: {"margin-top":"0.5rem"}
}
const _hoisted_8 = {
  class: "desc",
  style: {"flex":"1"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"auto","height":"0.9rem"}
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"0.2rem"} }, null, -1))
const _hoisted_11 = {
  class: "cls-con",
  style: {"margin-top":"0.2rem"}
}
const _hoisted_12 = {
  class: "desc",
  style: {"flex":"1"}
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"width":"auto","height":"0.9rem"}
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"0.2rem"} }, null, -1))
const _hoisted_15 = { class: "white-radius" }
const _hoisted_16 = { class: "cls-con" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "员工", -1))
const _hoisted_18 = {
  key: 0,
  class: "desc",
  style: {"text-align":"center"}
}
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "white-radius" }
const _hoisted_21 = { class: "cls-con" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "门店展板", -1))
const _hoisted_23 = {
  key: 0,
  class: "desc",
  style: {"text-align":"center"}
}
const _hoisted_24 = { class: "img-item" }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "img-title" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"3.5rem"} }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_button = _resolveComponent("van-button")!
  const _component_StaffItem = _resolveComponent("StaffItem")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_Tabbar = _resolveComponent("Tabbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("img", {
      src: _ctx.tenantInfo.thumb,
      style: {"width":"100%","height":"auto"}
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.tenantInfo.name), 1),
          _createVNode(_component_van_button, {
            plain: "",
            size: "mini",
            type: "warning",
            onClick: _ctx.qh_click
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 切换店铺")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_6, "营业时间：" + _toDisplayString(_ctx.tenantInfo.businessHours), 1),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, " 距离" + _toDisplayString(_ctx.tenantInfo.distanceTxt) + " | " + _toDisplayString(_ctx.tenantInfo.address) + " " + _toDisplayString(_ctx.tenantInfo.addressDetail), 1),
          _createElementVNode("div", {
            class: "black cls-flex",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.map_click && _ctx.map_click(...args))),
            style: {"min-width":"3rem"}
          }, [
            _hoisted_9,
            _hoisted_10,
            _createTextVNode(" 导航 ")
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, " 联系电话：" + _toDisplayString(_ctx.tenantInfo.leadPhone), 1),
          _createElementVNode("div", {
            class: "black cls-flex",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.tel_click && _ctx.tel_click(...args))),
            style: {"min-width":"3rem"}
          }, [
            _hoisted_13,
            _hoisted_14,
            _createTextVNode(" 拨号 ")
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", {
            class: "desc",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.all_staff_click && _ctx.all_staff_click(...args)))
          }, "查看全部 >")
        ]),
        (!_ctx.staffArr)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, " 没有员工信息 "))
          : (_openBlock(), _createElementBlock("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.staffArr, (staff) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: staff.id
                }, [
                  _createVNode(_component_StaffItem, { staff: staff }, null, 8, ["staff"])
                ]))
              }), 128))
            ]))
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("div", {
            class: "desc",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.all_img_click && _ctx.all_img_click(...args)))
          }, "查看全部 >")
        ]),
        (!_ctx.imgArr)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, " 暂时没有展板信息 "))
          : (_openBlock(), _createBlock(_component_van_row, {
              key: 1,
              gutter: "10",
              justify: "space-between"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imgArr, (img) => {
                  return (_openBlock(), _createBlock(_component_van_col, {
                    span: "12",
                    key: img.id
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("img", {
                          style: {"width":"100%","height":"auto"},
                          src: img.thumb
                        }, null, 8, _hoisted_25),
                        _createElementVNode("div", _hoisted_26, _toDisplayString(img.imgName), 1)
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128)),
                _createVNode(_component_van_col, { span: "12" })
              ]),
              _: 1
            }))
      ]),
      _hoisted_27
    ]),
    _createVNode(_component_Tabbar)
  ], 64))
}